module.exports = __webpack_public_path__ + "img/Card Pack.d949eda4.png";